<template>
  <Modal
    @closeModal="closeModal"
    v-show="showModal"
    :isLoading="isLoading"
    title="Delete Confirmation"
    :okFunction="deleteLayout"
  >
    <template v-slot:body>
      <div class="delete-description">Are you sure you want to delete this template?</div>
    </template>
  </Modal>
</template>

<script>
  import { apiDeleteTemplate } from '@/api/templates';

  import Modal from '@/components/common/Modal.vue';
  import { GENERIC_ERROR_MESSAGE } from '@/constant/const';

  export default {
    name: 'DeleteTemplateModal',

    components: { Modal },

    props: {
      templateId: {
        type: String,
        required: true,
      },
    },

    data() {
      return {
        showModal: false,
        isLoading: false,
      };
    },

    mounted() {
      this.showModal = true;
    },

    methods: {
      async deleteLayout() {
        this.isLoading = true;

        try {
          await apiDeleteTemplate(this.templateId);

          this.$toasted.global.general_success({
            message: 'Template deleted',
          });

          this.$emit('deleted');

          this.closeModal(true);
        } catch (error) {
          this.$toasted.global.general_error({
            message:
              error?.response?.data?.message ?? error?.data?.message ?? GENERIC_ERROR_MESSAGE,
          });
        }

        this.isLoading = false;
      },

      closeModal() {
        this.showModal = false;
        this.$emit('closeModal');
      },
    },
  };
</script>
